import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class VouchersService {


  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getVouchers(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/vouchers?' + size + urlParams;
    return this.http.get(url);
  }

  public getVouchersTotal(params: any) {
    let urlParams = '';
    const size = 'len=6';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    return this.http.get('web/vouchers/stats' + '?' + size + urlParams);
  }

  public createVoucher(voucher: any, edit: boolean) {
    return edit ? this.http.put('web/vouchers', voucher) : this.http.post('web/vouchers', voucher);
  }

  public generateCode(id: any, num: any) {
    return this.http.post(`web/vouchers/generate-codes?voucherId=${id}&codesCount=${num}`, {})
  }
}
